import { inject, Injectable } from "@angular/core";
import { AUTH_KEYS, AuthProvider, CustomAuthResponse, LoginType } from "../../interfaces/auth-response";
import { Observable, of, tap } from "rxjs";
import { HttpClient, HttpContext, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { BYPASS_AUTH } from "../../interceptors/auth.interceptor";
import { EnvironmentService } from "../../services/environment.service";


@Injectable({ providedIn: 'root' })
export class CustomAuthProvider implements AuthProvider {
    private environmentService = inject(EnvironmentService);

    constructor(
        private router: Router,
        private httpClient: HttpClient
    ) { }

    login(creds: {username: string, password: string}): Observable<any> {
        const params = new HttpParams()
            .set('username', creds.username)
            .set('password', creds.password)
            .set('client_id', this.environmentService.clientId())
            .set('client_secret', this.environmentService.clientSecret())
            .set('grant_type', 'password')
            .set('scope', 'openid');

        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };

        const context = new HttpContext().set(BYPASS_AUTH, true);

        return this.httpClient.post<CustomAuthResponse>('connect/token', params, { headers, context: context })
            .pipe(
                tap((response: CustomAuthResponse) => {
                    // this.isAuthenticatedSubject.next(true); // Aggiorna lo stato

                    // Setto il valore del token e refresh token e li salva nello storage
                    this.saveSession(response);
                })
            );
    }

    getToken(): Observable<string | null> {
        const token = localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN);
        
        //TODO: ad ora qui non ce la gestione del refresh token!

        if (token && this.isTokenExpired()) {
            console.warn('Token scaduto');
            return of(null);
        }
        
        return of(token);
    }

    isLoggedIn(): Observable<boolean> {
        const token = localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN);
        const isExpired = this.isTokenExpired();
        return of(!!token && !isExpired);
    }

    private isTokenExpired(): boolean {
        const expiresAt = localStorage.getItem(AUTH_KEYS.EXPIRES_AT);
        if (!expiresAt) return true;

        const expirationTime = parseInt(expiresAt, 10);
        const buffer = 15 * 1000; // 15 secondi di margine
        return (new Date().getTime() + buffer) > expirationTime;
    }

    logout() {
        localStorage.removeItem(AUTH_KEYS.LOGIN_TYPE);
        localStorage.removeItem(AUTH_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(AUTH_KEYS.REFRESH_TOKEN);
        localStorage.removeItem(AUTH_KEYS.EXPIRES_AT);
        console.log('Utente sloggato. Vado alla pagina di login');
        this.router.navigate(['/login']);
    }

    private saveSession(res: CustomAuthResponse) {
        localStorage.setItem(AUTH_KEYS.LOGIN_TYPE, LoginType.CUSTOM);
        localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, res.access_token);
        localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN, res.refresh_token!);// TODO: miss from WS

        const expiresInSeconds = Number(res.expires_in) ?? 3600;
        const nowMillis = new Date().getTime();
        // Momento in cui scade il token (in millisecondi)
        const expiresAt = nowMillis + (expiresInSeconds * 1000);
        localStorage.setItem(AUTH_KEYS.EXPIRES_AT, expiresAt.toString());
    }
}
